import { ChangePercentage, CountryCell, GroupTrafficShare, TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { column, options } from "app/components/React/Table/SWReactTableDefaults";
import { i18nFilter } from "app/filters/i18nFilter";

export default (isCompare: boolean) => ({
    columns: [
        column({
            field: "country",
            sortable: false,
            displayName: i18nFilter()("wwo.geography.table.country.header"),
            headerComponent: DefaultCellHeader,
            cellComponent: CountryCell,
        }),
        column({
            field: "share",
            displayName: i18nFilter()("wwo.geography.table.traffic.share.header"),
            type: "double",
            format: "percentagesign",
            sortable: true,
            isSorted: false,
            cellComponent: TrafficShare,
            headerComponent: DefaultCellHeader,
            sortDirection: "desc",
        }),
        isCompare
            ? column({
                  field: "shareList",
                  displayName: i18nFilter()("wwo.geography.table.traffic.share.list.header"),
                  headerComponent: DefaultCellHeader,
                  cellComponent: GroupTrafficShare,
                  sortable: false,
                  minWidth: 156,
              })
            : column({
                  field: "change",
                  displayName: i18nFilter()("wwo.geography.table.traffic.change.header"),
                  headerComponent: DefaultCellHeaderRightAlign,
                  cellComponent: ChangePercentage,
                  sortable: false,
                  minWidth: 88,
              }),
    ],
    options: options({
        tableType: "swTable--simple",
        showTitle: true,
        showTitleTooltip: true,
        titleType: "text",
        showSubtitle: true,
        showLegend: false,
        preserveLegendSpace: false,
        showSettings: false,
        showTopLine: false,
        showFrame: true,
        titleClass: "page-widget-title",
        emptyResults: false,
    }),
});
